import React from 'react';
import {Redirect} from 'react-router-dom';
import set from 'lodash/set';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {Input, Checkbox} from 'Components/Form';

import Auth from 'Services/Api/Auth/Auth';
import { Link } from "Components/Utilities";
import { asset } from "Services/BaseHelpers";

export default class SiteLogin extends React.Component {
    /**
     * @var state
     */
    state = {
        form: {},
        working: false,
        alert: null,
        redirect: null
    };

    /**
     * @method working
     * @param {boolean} working
     */
    working = (working = true) => {
        this.setState({
            working,
        });
    };

    /**
     * @method handleInput
     * @param {string} field
     * @param {string} value
     */
    handleInput = (field, value) => {
        const form = {
            ...this.state.form,
        };

        set(form, field, value);

        this.setState({ form });
    };

    /**
     * @method handleSubmit
     * @param {Event} e
     * @param {function} request
     * @param {null|string|function} onSuccess
     * @param {boolean} reset
     */
    handleSubmit = async (e, request = undefined, onSuccess = null, reset = false) => {
        if (e) {
            e.preventDefault();
        }

        if (request) {
            this.working();

            const response = await request(this.state.form);
            let alert = null;

            if (!response.success) {
                if (response?.status === 401) {
                    const response = await this.handleAutoRegister(onSuccess, reset);

                    return;
                }

                alert = {
                    message: response.message,
                    errors: response.errors,
                    type: 'error',
                };
            } else {
                if (typeof onSuccess === 'function') {
                    onSuccess(response);
                } else {
                    alert = {
                        type: 'success',
                        message: onSuccess,
                    };
                }
            }

            this.setState({
                alert,
                working: false,
                form: reset && response.success ? {} : this.state.form,
            });
        }
    };
    /**
     * @method handleAutoRegister
     * @param {null|string|function} onSuccess
     * @param {boolean} reset
     */
    handleAutoRegister = async (onSuccess, reset) => {
        this.working();

        let alert = null;

        const response = await Auth.register(this.state.form);

        if (!response.success) {
            alert = {
                message: response.message,
                errors: response.errors,
                type: 'error',
            };
        } else {
            if (typeof onSuccess === 'function') {
                onSuccess(response);
            } else {
                alert = {
                    type: 'success',
                    message: onSuccess,
                };
            }
        }

        this.setState({
            alert,
            working: false,
            form: reset && response.success ? {} : this.state.form,
        });

    };
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {form, working, alert, redirect} = this.state;

        if (redirect) {
            return <Redirect to={{
                pathname: redirect,
                state: { form }
            }}/>;
        }

        return (
            <Unauthenticated
                header={false}
                extraClasses={'flex flex-col justify-center items-center w-full'}
                logo={true}
            >
                <AuthLayout
                    title="Enter your details to play the games"
                    submitText="Continue"
                    onSubmit={(e) => this.handleSubmit(e, Auth.siteLogin, this.success, true)}
                    working={working}
                    alert={alert}
                >
                    <div className="mb-6">
                        <Input
                            placeholder="Employee UIN (your BT UIN)"
                            value={form.employee_uin}
                            onChange={v => this.handleInput('employee_uin', v)}
                        />
                    </div>

                    <div className="mb-6">
                        <Input
                            placeholder="Your work email address"
                            type="email"
                            value={form.email}
                            onChange={v => this.handleInput('email', v)}
                        />
                    </div>

                    <p className="text-white mb-6 text-xs rubrik-regular font-thin text-center">
                        @EE.co.uk @bt.com @openreach.co.uk @plusnet.co.uk @plus.net or your partner’s email address.
                    </p>

                    <div className="mb-6">
                        <Checkbox
                            label="Please select to confirm you agree with the Terms & Conditions"
                            value={form.terms_and_conditions}
                            onChange={v => this.handleInput('terms_and_conditions', v)}
                            labelTextColor="text-white"
                        />
                    </div>
                </AuthLayout>
            </Unauthenticated>
        );
    }
}
